/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IDiagLab } from 'app/shared/model/diag-lab.model';
import { IAppointments } from 'app/shared/model/appointments.model';
import { IDiaglabAssistant } from 'app/shared/model/diaglab-assistant.model';
import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { IDoctor } from 'app/shared/model/doctor.model';
import { IImageTests } from 'app/shared/model/image-tests.model';
import { IPrescription } from 'app/shared/model/prescription.model';
import { ILabPrescription } from 'app/shared/model/lab-prescription.model';
import { ITreatmentPlan } from 'app/shared/model/treatment-plan.model';
import { IPatientProcedure } from 'app/shared/model/patient-procedure.model';
import { PatientType } from 'app/shared/model/enumerations/patient-type.model';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';

export interface IRadiologyStudy {
  id?: string;
  instructions?: string | null;
  dateActivated?: number | null;
  autoExpireDate?: number | null;
  dateStopped?: number | null;
  reason?: string | null;
  microSec?: number | null;
  voided?: boolean | null;
  voidedBy?: string | null;
  dateVoided?: number | null;
  voidReason?: string | null;
  urgency?: string | null;
  orderStatus?: string | null;
  scheduledDate?: number | null;
  timestampentry?: number | null;
  lastupdated?: number | null;
  cursor?: number;
  active?: boolean | null;
  otc?: boolean | null;
  patientType?: keyof typeof PatientType | null;
  exposed?: boolean | null;
  addedByType?: keyof typeof AddedByType | null;
  addedByID?: string | null;
  modifiedByType?: keyof typeof AddedByType | null;
  modifiedByID?: string | null;
  servedBy?: IDiagLab | null;
  appointment?: IAppointments | null;
  otcBy?: IDiaglabAssistant | null;
  patient?: IGlucoUser | null;
  orderedBy?: IDoctor | null;
  imageTests?: IImageTests | null;
  prescription?: IPrescription | null;
  labPrescription?: ILabPrescription | null;
  treatmentPlan?: ITreatmentPlan | null;
  procedure?: IPatientProcedure | null;
}

export const defaultValue: Readonly<IRadiologyStudy> = {
  voided: false,
  active: false,
  otc: false,
  exposed: false,
};
